import { Box, Typography } from "@mui/material";
import React from "react";

const PreviewField = (props: { text: string }) => {
  return (
    <Box minHeight={40} display="flex" pt={"8px"} justifyContent="start">
      <Typography>{props.text || "-"}</Typography>
    </Box>
  );
};

export default PreviewField;
